import IStack from "./IStack";

class SimpleStack<T> implements IStack<T> {
    private storage: T[] = [];

    constructor(private capacity: number = Infinity) {
    }

    push(item: T): void {
        if (this.size() === this.capacity) {
            throw Error("Stack has reached max capacity, you cannot add more items");
        }
        this.storage.push(item);
    }

    pop(): T {
        let result = this.storage.pop();
        if(result == undefined) {
            throw new Error("stack is empty")
        }
        return result
    }

    clear(): void {
        this.storage = []
    }

    size(): number {
        return this.storage.length;
    }

    toArray(): Array<T> {
        return this.storage;
    }
}

export default SimpleStack